import { UserRole, type User } from '@promtver/contracts';

/**
 * Признак «доступ ждёт подтверждения администратора»: представитель предприятия
 * зарегистрировался, но ещё не привязан к объекту (FR-B2B-01, FR-ADM-04).
 *
 * Без этой проверки сервер отвечает 403 на любой запрос /partner/*, и
 * пользователь видит «нет прав» вместо понятного «ждём подтверждения».
 */
export function isAwaitingApproval(user: User | null): boolean {
  if (!user) return false;
  return user.role === UserRole.ObjectModerator && !user.enterpriseId;
}

/** Маршрут, на который попадает пользователь после входа. */
export function homeRouteFor(user: User | null): string {
  return isAwaitingApproval(user) ? '/pending' : '/scanner';
}
